import {
    RequestConfigFunction,
    RequestForDomainForm,
} from 'app/types/request.types'

type GatewayDeploymentRequests = {
    domainName: string,
    filterRequest: RequestConfigFunction<{params?: Record<string, any>}>,
    get: RequestConfigFunction<{id: number}>,
    update: RequestForDomainForm<{id: number}>,
    create: RequestForDomainForm<undefined>,
    archive: RequestConfigFunction<{id: number}>,
    restore: RequestConfigFunction<{id: number}>,
}

const gatewayDeploymentRequests: GatewayDeploymentRequests = {
    domainName: 'Deployment',
    filterRequest: ({
        params = {},
    } = {}) => {
        return {
            url: 'gateway/deployment/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `gateway/deployment/${id}`,
            method: 'GET',
        }
    },
    update: {
        name: 'Deployment',
        request: ({
            id,
        }) => {
            return {
                url: `gateway/deployment/${id}`,
                method: 'PUT',
                domainName: 'Deployment',
            }
        },
    },
    create: {
        name: 'Deployment',
        request: () => {
            return {
                url: 'gateway/deployment',
                method: 'POST',
                domainName: 'Deployment',
            }
        },
    },
    archive: ({
        id,
    }) => {
        return {
            url: `gateway/deployment/${id}/archive`,
            method: 'PATCH',
        }
    },
    restore: ({
        id,
    }) => {
        return {
            url: `gateway/deployment/${id}/restore`,
            method: 'PATCH',
        }
    },
}

export default gatewayDeploymentRequests
